import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userSlice';
import infoReducer from '../features/infoSlice';
import chatReducer from '../features/chatSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    chat: chatReducer,
    info: infoReducer,
  },
});
